export function convertStringToRegex(ugc: string, includeFlags: string[] = []) {
  if (ugc.startsWith('/')) {
    const optionsIndex = ugc.lastIndexOf('/')
    const [rPart, options] = [
      ugc.substring(1, optionsIndex),
      ugc.substring(optionsIndex + 1),
    ]
    try {
      return new RegExp(rPart, options + includeFlags.join(''))
    } catch {
      return undefined
    }
  }
}
